import React from "react";
import { idEq } from "../../utils/bondchat/chatReadHelpers";

const ReactionChips = ({ reactions, userId, onToggle, alignEnd = false }) => {
  const list = (reactions || []).filter((r) => (r.users || []).length > 0);
  if (!list.length) return null;

  return (
    <div className={`bc-reaction-chips ${alignEnd ? "bc-reaction-chips-end" : ""}`}>
      {list.map((r) => {
        const mine = (r.users || []).some((id) => idEq(id, userId));
        return (
          <button
            key={r.emoji}
            type="button"
            className={`bc-reaction-chip ${mine ? "bc-reaction-chip-mine" : ""}`}
            onClick={() => onToggle?.(r.emoji)}
          >
            <span className="bc-reaction-chip-emoji">{r.emoji}</span>
            <span className="bc-reaction-chip-count">{r.users.length}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ReactionChips;
